import { ENDPOINTS } from '../endpoints';
import {
  CityDto,
  CorregimientoDto,
  CountryDto,
  CreateCityDto,
  CreateCorregimientoDto,
  CreateCountryDto,
  CreateRegionDto,
  CreateVeredaDto,
  RegionDto,
  UpdateCityDto,
  UpdateCorregimientoDto,
  UpdateCountryDto,
  UpdateRegionDto,
  UpdateVeredaDto,
  VeredaDto,
} from '../types/dtos';
import { BaseService } from './base.service';

export class CountryService extends BaseService<CountryDto, CreateCountryDto, UpdateCountryDto> {
  constructor() {
    super(ENDPOINTS.countries.base());
  }
}

export class RegionService extends BaseService<RegionDto, CreateRegionDto, UpdateRegionDto> {
  constructor() {
    super(ENDPOINTS.regions.base());
  }
}

export class CityService extends BaseService<CityDto, CreateCityDto, UpdateCityDto> {
  constructor() {
    super(ENDPOINTS.cities.base());
  }
}

export class CorregimientoService extends BaseService<CorregimientoDto, CreateCorregimientoDto, UpdateCorregimientoDto> {
  constructor() {
    super(ENDPOINTS.corregimientos.base());
  }
}

export class VeredaService extends BaseService<VeredaDto, CreateVeredaDto, UpdateVeredaDto> {
  constructor() {
    super(ENDPOINTS.veredas.base());
  }
}

// Service instances
export const countryService = new CountryService();
export const regionService = new RegionService();
export const cityService = new CityService();
export const corregimientoService = new CorregimientoService();
export const veredaService = new VeredaService(); 